<template>
  <b-card class="h-100">
    <b-row>
      <div class="col-md-3 d-flex flex-column">
        <b-form-checkbox-group buttons v-model="reportTypeFilter" :options="form.tipo.options" value-field="code" text-field="label" button-variant="third" @input="onChangeFilter"></b-form-checkbox-group>
        <tables ref="tableGrid"
                :columns="['Descrição', $lang.Common.DataTable.Actions]"
                :showPaging="false"
                :showHeader="false">
          <tr v-for="obj in this.objListFiltered" :key="obj.id">
                <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :value="obj.descricao" />
                <TableColumn :HasChange="false" :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" />
          </tr>
        </tables>
      </div>
      <forms :title="$lang.PCI.Reports.Title"
             class="col-md-9"
             :showSaveButton="true"
             :showClearButton="true"
             @Clear="onClear"
             @Save="onSave">
        <b-form-group :label="$lang.PCI.Reports.LabelDescription">
          <b-form-input v-model="form.descricao.value"
                        :require="form.descricao.required"
                        :state="form.descricao.state">
          </b-form-input>
        </b-form-group>
        <b-form-group :label="$lang.PCI.Reports.LabelType">
          <v-select v-model="form.tipo.value" :options="form.tipo.options" :required="form.tipo.required" :state="form.tipo.state" :reduce="type => type.code"></v-select>
        </b-form-group>
        <b-card class="mt-3 mb-0">
          <template #header>
            <strong>{{'Itens'}}</strong>
            <div class="card-actions">
              <a href="#" @click="onShowItems"><i class="fas fa-plus"></i></a>
            </div>
          </template>
          <b-form-group v-for="(item, index) in form.itens.value" :key="index">
            <div class="d-flex" style="align-items: center;">
              <div class="d-flex col mr-3 p-0 align-items-center">
                <i v-if="item.tipoItem === 1" class="fas fa-thumbtack mr-2"></i>
                <i v-else class="fas fa-list mr-1"></i>
                <!-- <label class="m-0 mr-3">{{ $lang.PCI.Reports.Item['ItemType' + item.tipoItem] }}</label> -->
                <b-form-input v-model="item.parents" disabled></b-form-input>
              </div>
              <b-form-input v-model="item.descricao" class="col-3 mr-3"></b-form-input>
              <b-button variant="light"
                        @click="onRemoveItem(index)">
                <i class="fas fa-trash"></i>
              </b-button>
            </div>
          </b-form-group>
        </b-card>
      </forms>
    </b-row>

    <b-modal ref="modalItems" id="reportModalItems" :title="'Itens'" :hide-footer="true">
      <b-tabs>
        <b-tab>
          <template #title><i class="fas fa-list"></i> {{ $lang.PCI.Reports.Item.ItemType0 }}</template>
          <div>
            <item-tree-view ref="statusTreeview"
                            :list="item.options"
                            :serializer="it => it.name"
                            v-on:selectitem="onSelectItem" />
          </div>
        </b-tab>
        <b-tab>
          <template #title><i class="fas fa-thumbtack"></i> {{ $lang.PCI.Reports.Item.ItemType1 }}</template>
          <div v-for="item in fixedItem" :key="item.code">
            <div class="mt-2" v-if="(item.code % 10) === 0">
              <strong>{{ item.text }}</strong>
            </div>
            <div v-else>
              <a href="#" class="text-secondary ml-3" @click="onSelectFixedItem(item)">{{ item.text }}</a>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </b-card>

</template>

<script>
import Reports from './reports.js'
export default Reports
</script>

<style scoped>
  #reportModalItems .modal-body {
    overflow-y: auto;
    height: calc(100vh - 185px);
  }
  * >>> .btn-group-toggle.btn-group .btn.btn-third.active {
    background-color: darkgreen !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reports/reports.vue